import classNames from "classnames";
import { Immutable } from "immer";
import React, { type JSX } from "react";
import { Image } from "tsi-common-react/src/components/Image/index";
import { Link } from "tsi-common-react/src/components/Link/index";
import { jt } from "ttag";

import { IDropdownMenuItem } from "./menu.interface";

type IProps = Immutable<{
    isActive: boolean;
    isMobile: boolean;
    linksArray: IDropdownMenuItem[];
    linkID: number;
    hasAdverts?: boolean;
}>;

export const DropdownLinks = ({
    isActive,
    isMobile,
    linksArray,
    linkID,
    hasAdverts = false,
}: IProps): React.ReactNode => {
    const dropdownLinks = linksArray.map((obj, id) => {
        let badge: JSX.Element | null = null;
        if (obj.value.badge) {
            if (isMobile) {
                badge = (
                    <span>
                        <span className="menu-dropdown-badge menu-dropdown-badge--mobile">
                            {obj.value.badge.mobile_text}
                        </span>
                    </span>
                );
            } else {
                badge = (
                    <span>
                        <Image
                            className={`menu-dropdown-badge menu-dropdown-badge--${obj.value.badge.position}`}
                            src={obj.value.badge.image.url}
                            alt={obj.value.badge.mobile_text}
                            lazy={false}
                        />
                    </span>
                );
            }
        }
        const titleClass = classNames({
            "menu-dropdown-block--lg-title": !isMobile,
            "menu-dropdown-block--sm-title": isMobile,
        });
        const pageURL =
            obj.type === "snippet_link" ? obj.value.link : obj.value.page.url;
        const target = obj.value.open_in_new_tab ? "_blank" : "_top";
        const rel = target === "_blank" ? "noopener noreferrer" : "";
        return (
            <Link
                key={id}
                href={pageURL}
                className="menu-dropdown-block"
                target={target}
                rel={rel}
                title={jt`Shop ${obj.value.override_title}`.toString()}
            >
                {badge}
                <Image
                    className="menu-dropdown-block--image"
                    src={obj.value.image.url}
                    alt={obj.value.image.title}
                    lazy={false}
                />
                <p className={titleClass}>{obj.value.override_title}</p>
            </Link>
        );
    });
    const linkClass = classNames({
        "main-dropdown-menu__shop-links": true,
        "main-dropdown-menu__shop-links--mobile": isMobile,
        "main-dropdown-menu__shop-links--mobile-active": isMobile && isActive,
        "main-dropdown-menu__shop-links--no-adverts": !isMobile && !hasAdverts,
    });
    return (
        <div
            aria-expanded={isActive}
            className={linkClass}
            key={linkID}
            data-subnav={linkID}
        >
            {dropdownLinks}
        </div>
    );
};
